import * as React from 'react';
import { Alert } from 'reactstrap';

/**
 * Warning Props
 */
interface WarningProps {
	message: string | JSX.Element;
}

/**
 * Reusable Warning Alert Component used by AdminErrorBoundary and Listing/Tree base components.
 *
 * @class Warning
 * @extends {React.Component<any, any>}
 */
class Warning extends React.Component<WarningProps, any> {
	constructor(props: WarningProps) {
		super(props);
	}

	public render() {
		return (
			<Alert color="warning">
				<h2>Warning</h2>
				{this.props.message}
			</Alert>
		);
	}
}

export default Warning;
